import $ from 'jquery';

export default class DisplayView {
	init() {
		this.displayView();
	}
	displayView(){
		$('.show_list').click(function(){
			document.cookie = "show_list=true; expires=Thu, 30 Jan 2100 12:00:00 UTC; path=/";
			$('#js-product-list .products').removeClass('grid');
			$('#js-product-list .products').addClass('list');
			$('.show_grid').removeClass('active');
			$('.show_list').addClass('active');
		});
		 
		$('.show_grid').click(function(){
			document.cookie = "show_list=; expires=Thu, 30 Jan 1970 12:00:00 UTC; path=/";
			$('#js-product-list .products').removeClass('list');
			$('#js-product-list .products').addClass('grid');
			$('.show_list').removeClass('active');
			$('.show_grid').addClass('active');
		});
		 
		prestashop.on('updateProductList', function (event) {
			$('.show_list').click(function(){
				$('#js-product-list .products').removeClass('grid');
				$('#js-product-list .products').addClass('list');
				$('.show_grid').removeClass('active');
				$('.show_list').addClass('active');
			});
			 
			$('.show_grid').click(function(){
				$('#js-product-list .products').removeClass('list');
				$('#js-product-list .products').addClass('grid');
				$('.show_list').removeClass('active');
				$('.show_grid').addClass('active');
			});
		});
	}
}


// WEBPACK FOOTER //
// ./js/components/display-view.js